import {
  ChoicesArticleCombination,
  ChoicesRelatedCombination,
} from "@generated"

export type NormalizedRelatedCombination = Omit<
  ChoicesRelatedCombination,
  "combinations"
> & {
  combination: ChoicesArticleCombination
  variants: ChoicesArticleCombination[]
}

export function getNormalizedRelatedCombinations(
  items: ChoicesRelatedCombination[],
  activeCombinationId?: string
): NormalizedRelatedCombination[] {
  return items.map((item) => {
    const { combinations, ...rest } = item

    let combination = combinations[0]
    let variants = combinations.slice(1)

    if (activeCombinationId) {
      const activeCombination = combinations.find(
        (combination) => combination.id === activeCombinationId
      )

      if (activeCombination) {
        combination = activeCombination
        variants = combinations.filter(
          (combination) => combination.id !== activeCombinationId
        )
      }
    }

    return {
      ...rest,
      combination,
      variants,
    }
  })
}
